import {
  TRAVELINFO_DISTURBANCE_BASEURL,
  TRAVELINFO_DISTURBANCE_KEY,
} from '../constants'
import { format } from 'date-fns'
import { DEFAULT_API_DATE_TIME_FORMAT } from '../../constants'

type DisturbanceList = Disturbance[]
export type Disturbance = {
  description: string // 'Door een ongeval is de dienstregeling van alle lijnen ernstig verstoord.'
  impactedLines: { id: string; directionCode: string }[] // [{ id: '1850', directionCode: '1'}]
  disruptedStops: { id: string }[] // [{ id: '103307' }]
}

export async function getMultipleDisturbancesForStops({
  startDateTime,
  stopIds,
}: {
  startDateTime: Date
  stopIds: string[]
}) {
  let hasErrors = false
  const responses: PromiseSettledResult<Disturbance[]>[] =
    await Promise.allSettled(
      stopIds.map((stopId: string) =>
        getDisturbancesForStop({
          stopId,
          startDateTime,
        }),
      ),
    )

  const disturbances = responses
    .map((response) => {
      if (response.status === 'fulfilled') {
        return response.value
      }
      hasErrors = true
      return null
    })
    .filter(Boolean)
    .flat(1) as Disturbance[]

  if (!disturbances.length && hasErrors) {
    throw new Error(
      'No disturbances were returned and at least one call had an error',
    )
  }

  return disturbances
}

export async function getDisturbancesForStop({
  startDateTime,
  stopId,
}: {
  startDateTime: Date
  stopId: string
}) {
  const searchParams = new URLSearchParams({
    startDateTime: format(startDateTime, DEFAULT_API_DATE_TIME_FORMAT), // Start date at which the disturbance needs to be active
    // endDateTime: format(endDateTime, DEFAULT_API_DATE_TIME_FORMAT), // End date until which the disturbance needs to be active (default to the start date)
    lang: 'nl', // currently only supports dutch
  })

  const url =
    `${TRAVELINFO_DISTURBANCE_BASEURL}/stops/${stopId}/disturbances?` +
    searchParams.toString()

  const data: { disturbances: DisturbanceList } = await fetch(url, {
    headers: {
      'Ocp-Apim-Subscription-Key': TRAVELINFO_DISTURBANCE_KEY as string,
    },
  }).then((data) => data.json())
  return data.disturbances
}
